<template>
    <b-form-group
        :label="$t('Component(OrganizationSelector):label-organization')"
        label-for="organization"
    >
        <treeselect
            id="organization"
            :options="organizations"
            noChildrenText=""
            :normalizer="normalize"
            v-model="organization"
            @input="change"
            valueFormat="object"
            :show-count="true"
        />
    </b-form-group>
</template>

<script>
import {BFormGroup} from 'bootstrap-vue'
import Treeselect from '@riophae/vue-treeselect'
import {SupplyChain} from "@core/api";

export default {
    components: {
        BFormGroup, Treeselect
    },
    props: {
        selected: {
            type: Object,
            default() {
                return null;
            }
        },
        type: {
            default: null
        }
    },
    data() {
        return {
            organizations: [],
            organization: this.selected
        };
    },
    methods: {
        normalize(node) {
            return {id: node.id, label: node.title};
        },
        init(organizations) {
            organizations.forEach(this.initObject);
            this.organizations = organizations;
        },
        initObject(organization) {
            if (null === organization.children || organization.children.length === 0) {
                delete organization.children;
            } else {
                organization.children.forEach(this.initObject);
            }
        },
        change() {
            this.$emit('input', this.organization);
        }
    },
    created() {
        SupplyChain.getOrganizations(true, this.type).then(r => this.init(r.data));
    },
    watch: {
        selected(v) {
            this.organization = v;
        }
    }
}
</script>
<style lang="scss">
@import '../../../../node_modules/@riophae/vue-treeselect/dist/vue-treeselect.css';
</style>
